import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, filter, finalize, map } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { BonusApi } from 'src/app/shared/apis/bonus.api';
import { NewBonusWalletApi } from 'src/app/shared/apis/new-bonus-wallet.api';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { CsPopupService } from 'src/app/shared/components/cs-popup/cs-popup.service';
import { ICSOption } from 'src/app/shared/components/cs-select/cs-select.component';
import { CSTabComponent } from 'src/app/shared/components/cs-tab/cs-tab.component';
import { EmptyModule } from 'src/app/shared/components/empty/empty.module';
import { ProgressBarComponent } from 'src/app/shared/components/progress-bar/progress-bar.component';
import { UserAvatarComponent } from 'src/app/shared/components/user-avatar/user-avatar.component';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { AccountInforData } from 'src/app/shared/interfaces/account.interface';
import {
  BonusDetailList,
  BonusSelect,
  BonusTypeList,
  NewBonusWalletType,
  SeenType,
} from 'src/app/shared/interfaces/bonus.interface';
import { ActiveBonus, EligibleBonus } from 'src/app/shared/interfaces/new-bonus-wallet.interface';
import { TenantConfig } from 'src/app/shared/interfaces/resource.interface';
import { CurrencyValuePipe } from 'src/app/shared/pipes/currency-value.pipe';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatConnectedDialog, MatConnectedDialogMobileAnimation } from 'src/app/shared/service/connected-dialog';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { CardCenterService } from '../card-center/card-center.service';
import { MiniGameService } from '../minigame/minigame.service';
import { SettingsService } from '../settings/settings.service';
import { UserAssetsService } from '../user-asset/user-assets.service';
import { faq } from '../vip/vip.component';
import { WalletService } from '../wallet/wallet.service';
import { BonusesRulesComponent, BonusItem } from './bonuses-rules/bonuses-rules.component';
import { CashbackRedemptionComponent } from './cashback-redemption/cashback-redemption.component';
import { ClaimBonusByCurrencyComponent } from './claim-bonus-by-currency/claim-bonus-by-currency.component';
import { LockedBonusesComponent } from './locked-bonuses/locked-bonuses.component';
import { RedeemCodeComponent } from './redeem-code/redeem-code.component';
@UntilDestroy()
@Component({
  selector: 'app-bonuses',
  standalone: true,
  imports: [
    CSTabComponent,
    PipesModule,
    UserAvatarComponent,
    CSButtonComponent,
    EmptyModule,
    LoadingModule,
    CSIconButtonComponent,
    ProgressBarComponent,
  ],
  templateUrl: './bonuses.component.html',
  styleUrl: './bonuses.component.scss',
})
export class BonusesComponent implements OnInit, AfterViewInit {
  public tabs: string[] = ['View All', 'Active', 'Eligible'];
  public tabMapping: { [key: string]: string } = {
    'View All': 'view-all',
    Active: 'active',
    Eligible: 'eligible',
  };
  public tabIcons: string[] = ['fi-eye-filled', 'fi-check-circle-filled', 'fi-eligible-bonuses'];
  public tabIndex: number = 0;
  public direction: 'vertical' | 'horizontal' = 'vertical';
  public tabWidth: 'full' | 'auto' = 'full';
  public animationDelay: number = 100;

  protected readonly NewBonusWalletType = NewBonusWalletType;

  /** 可兌換幣種列表 */
  cryptoCurrencies: ICSOption[] = [];
  /** 歷年領過的獎金 */
  totalClaimAmount: number = 0;
  /** 獎金錢包鎖定住的獎金 */
  lockedBonusAmount: number = 0;
  /** 獎金錢包鎖定住的獎金 */
  // lockedBonusAmountDetail: any;
  /** 激活獎金錢包loader */
  isActiveBonusLoading: boolean = false;
  /** 激活獎金錢包列表 */
  activeBonusList: (ActiveBonus & { logo: string })[] = [];
  /** 未激活獎金錢包列表 */
  eligibleBonusList: EligibleBonus[] = [];
  /** 一般獎金錢包loader */
  isCouponCardLoading: boolean = false;
  /** 一般獎金錢包列表 */
  couponCardList: BonusDetailList[] = [];
  /** 取得VIP遊戲返水跟救援金 */
  longTermBonusDetail: any = [];
  /** longTermBonusDetail的合併參數，bind版使用 */
  cashbackData: {
    multiCurrency: any;
    amount: number;
    totalCapInUsdt: number;
    percent: number;
  } = {
    multiCurrency: [],
    amount: 0,
    totalCapInUsdt: 0,
    percent: 0,
  };
  /** 第一區loader */
  sectionOneLoading: boolean = false;
  /** 第三區loader */
  sectionThreeLoading: boolean = false;
  /** 領取cashback loader 顯示於按鈕上*/
  clickClaimCashbackLoading: boolean = false;
  /** 放棄激活獎金 loader 顯示於按鈕上*/
  forfeitDataLoading: boolean = false;

  @ViewChild('tabRefs') tabComponent!: any;
  @ViewChild('tabContainer', { read: ElementRef }) tabElementRef!: ElementRef;
  @ViewChild('bonusesAnchor', { read: ElementRef }) bonusesAnchorRef!: ElementRef<HTMLElement>;
  @ViewChild('BonusActive', { read: ElementRef }) bonusActiveRef!: ElementRef<HTMLElement>;
  private isAutoScrolling = false;

  /** 用戶訊息 */
  userInfo: AccountInforData | null = null;

  /** 卡券類型 目前沒有使用 先獲取 */
  cardTypeList: BonusTypeList[] = [];
  /** 卡券狀態 */
  cardStatusList: BonusSelect[] = [];
  /** typeCode與圖片mapping表 */
  public typeCodeImageMap: { [key: string]: string } = {
    vip_promote: 'level-up', // 晋级福利
    vip_keep: '', // 保级福利
    vip_birthday: 'birthday', // 生日礼金
    vip_login: 'login', // 登录红包
    vip_deposit: 'bonus-wallet', // 存款福利
    vip_cashback: '', // 救援金
    vip_transaction: '', // 交易返还
  };
  /** grant與圖片mapping表 */
  public grandTypeImageMap: { [key: string]: string } = {
    Cash: 'cash-voucher',
    FreeSpin: 'free-spins',
    FreeChip: 'free-chips',
  };
  /** walletType 與圖片mapping表 */
  public walletTypeImageMap: { [key: string | number]: string } = {
    Default: 'bonus-wallet',
    [NewBonusWalletType.FreeSpin]: 'free-spins',
    [NewBonusWalletType.FreeChip]: 'free-chips',
  };
  public bonusFaqs: faq[] = [];

  allRate: any = {};
  currentCurrency: string = '';
  currencyAmountList: { currency: string; amount: number; minAmount: number; maxAmount: number }[] = [];
  isMultiplePrize: boolean = false;

  @HostListener('window:resize')
  onWindowResize() {
    this.updateDirectionByViewport();
  }

  constructor(
    private router: Router,
    private appService: AppService,
    private settingsService: SettingsService,
    private csPopupService: CsPopupService,
    private bonusApi: BonusApi,
    private newBonusWalletApi: NewBonusWalletApi,
    private matConnectedDialog: MatConnectedDialog,
    private localeService: LocaleService,
    private walletService: WalletService,
    private currencyValue: CurrencyValuePipe,
    private toast: ToastService,
    protected miniGameService: MiniGameService,
    private userAssetsService: UserAssetsService,
    private cardCenterService: CardCenterService,
  ) {}

  ngOnInit(): void {
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(res => {
      if (!res) return;
      this.userInfo = res;

      // 標示已讀，設定獎金中心數量
      this.bonusApi.seenBonusCount({ seenType: SeenType.BonusUnclaimed }).subscribe(() => {
        this.cardCenterService.bounsCount$.next(0);
      });
    });
    this.appService.currencies$.subscribe((data: any[]) => {
      const filtered = data.filter(c => c.isDigital !== false && c.isVisible !== false);
      this.cryptoCurrencies = filtered.map(item => ({
        label: item.name,
        img: item.icon,
        value: item.currency,
      }));
    });
    this.bonusFaqs = this.parseConfigJson<faq>('bonusFaq');
    // 獲取導航資料
    this.getInitData();
    //第一組
    this.loadSectionOne();
    // 第二組
    this.getActiveBonusData();
    // 第三組
    combineLatest([this.userAssetsService.allRate, this.appService.currentCurrency$])
      .pipe(
        filter(([rateData, currency]) => rateData?.rates?.length > 0 && !!currency),
        untilDestroyed(this),
      )
      .subscribe(([rateData, currency]) => {
        this.allRate = rateData;
        this.currentCurrency = currency.currency;

        if (this.eligibleBonusList.length === 0 || this.couponCardList.length === 0) {
          this.loadSectionThree();
        } else {
          this.formatEligibleBonusData();
        }
      });
  }
  public onTabChanged(index: number): void {
    this.tabIndex = index;
    if (this.isMobileViewport()) {
      this.scrollToBonusesSection();
    }
  }
  private updateDirectionByViewport() {
    const isWide = window.innerWidth >= 900;

    this.direction = isWide ? 'vertical' : 'horizontal';
    this.tabWidth = isWide ? 'full' : 'auto';
  }
  private setTabIndex(): void {}
  public ngAfterViewInit(): void {
    this.updateDirectionByViewport();
    setTimeout(() => {
      this.setTabIndex();
    }, this.animationDelay);
  }
  /**
   * 載入第一組資料
   * 包含 Loyalty Program 資訊、長期獎金、總領取紅利、獎金錢包鎖定金額
   */
  loadSectionOne() {
    this.sectionOneLoading = true;
    combineLatest([
      this.bonusApi.getLongTermBonusDetails(),
      this.bonusApi.getTotalCompletedBonusAndNewBonusAmount(),
      this.newBonusWalletApi.getActiveBonusBalance(),
    ]).subscribe(([longTermBonusDetails, totalClaimAmountRes, lockedBonusAmountRes]) => {
      // 處理 longTermBonusDetails
      if (longTermBonusDetails) {
        this.longTermBonusDetail = longTermBonusDetails.map((item: any) => ({
          ...item,
          multiCurrency: Object.entries(item?.multiCurrency || {}).map(([currency, balance]) => ({
            currency,
            balance,
          })),
        }));
        const amount = this.longTermBonusDetail.reduce((sum: number, item: any) => sum + (item.amount || 0), 0);
        const totalCapInUsdt = this.longTermBonusDetail.reduce(
          (sum: number, item: any) => sum + (item.totalCapInUsdt || 0),
          0,
        );

        // 找出vip_transaction和vip_cashback
        const vipTransaction = this.longTermBonusDetail.find((item: any) => item.typeCode === 'vip_transaction');
        const vipCashback = this.longTermBonusDetail.find((item: any) => item.typeCode === 'vip_cashback');

        // 如果都存在且vip_transaction有multiCurrency
        if (vipTransaction && vipTransaction.multiCurrency && vipCashback && vipCashback.amount) {
          // 找到usdt币种
          const usdtCurrency = vipTransaction.multiCurrency.find((c: any) => c.currency === 'USDT');
          if (usdtCurrency) {
            usdtCurrency.balance += vipCashback.amount;
          } else {
            // 如果没有usdt币种则添加
            vipTransaction.multiCurrency.push({ currency: 'USDT', balance: vipCashback.amount });
          }
        }

        this.cashbackData = {
          multiCurrency: vipTransaction?.multiCurrency || [],
          amount,
          totalCapInUsdt,
          percent: totalCapInUsdt ? (amount / totalCapInUsdt) * 100 : 0,
        };
      } else {
        this.longTermBonusDetail = [];
      }

      // 處理 totalClaimAmount
      if (totalClaimAmountRes?.success) {
        this.totalClaimAmount = totalClaimAmountRes.data;
      }

      // 處理 lockedBonusAmount
      if (lockedBonusAmountRes) {
        this.lockedBonusAmount = lockedBonusAmountRes.balance;
      }

      this.sectionOneLoading = false;
    });
  }

  private scrollToBonusesSection(): void {
    if (this.isAutoScrolling) return;

    const target = this.bonusesAnchorRef?.nativeElement || this.bonusActiveRef?.nativeElement;
    if (!target) return;

    this.isAutoScrolling = true;
    const scrollTarget = this.findScrollContainer(target);
    const offsetTop = this.getOffsetTop(target, scrollTarget);
    const padding = 60; // leave more room for header/nav on mobile

    requestAnimationFrame(() => {
      if (scrollTarget) {
        scrollTarget.scrollTo({ top: offsetTop - padding, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: offsetTop - padding, behavior: 'smooth' });
      }

      // Allow manual scrolling again after the animation.
      setTimeout(() => (this.isAutoScrolling = false), 350);
    });
  }

  private findScrollContainer(element: HTMLElement | null): HTMLElement | null {
    let node = element?.parentElement;

    while (node && node !== document.body) {
      const style = window.getComputedStyle(node);
      const canScroll =
        (style.overflowY === 'auto' || style.overflowY === 'scroll') && node.scrollHeight > node.clientHeight + 1;
      if (canScroll) {
        return node;
      }
      node = node.parentElement;
    }

    return document.scrollingElement as HTMLElement;
  }

  private getOffsetTop(element: HTMLElement, scrollContainer: HTMLElement | null): number {
    let offset = 0;
    let node: HTMLElement | null = element;

    while (node && node !== scrollContainer && node.offsetParent instanceof HTMLElement) {
      offset += node.offsetTop;
      node = node.offsetParent;
    }

    return offset;
  }

  private isMobileViewport(): boolean {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  /**
   * 載入第三組資料
   * 包含符合條件的獎金、卡券資料
   */
  loadSectionThree() {
    this.sectionThreeLoading = true;
    combineLatest([
      this.newBonusWalletApi.getEligibleBonus(),
      this.bonusApi.getBonusDetailV2(
        {
          pageIndex: 1,
          pageSize: 50,
          grantType: '',
          typeCode: '',
          status: 'Unclaimed',
          ascSort: false,
        },
        this.appService.sysConfig$.value?.handlingFeeType,
      ),
    ]).subscribe(([eligibleBonusRes, couponCardRes]) => {
      this.eligibleBonusList = eligibleBonusRes || [];
      this.formatEligibleBonusData();
      this.couponCardList = (couponCardRes.list || []).map((item: any) => {
        const logo =
          item.walletType === NewBonusWalletType.FreeSpin
            ? this.grandTypeImageMap['FreeSpin']
            : item.walletType === NewBonusWalletType.FreeChip
              ? this.grandTypeImageMap['FreeChip']
              : this.typeCodeImageMap[item.typeCode] || this.grandTypeImageMap[item.grantType] || 'default';

        return {
          ...item,
          logo,
          loading: false,
          cardStatusDesc: this.cardStatusList?.find((v: any) => v?.code === item?.cardStatus)?.description || '',
          toParseIntAmount: this.toParseInt(
            this.currencyValue.transform(
              item.cardStatus === 'InUse' ? (item.balance ?? 0) : (item.amount ?? 0),
              item?.currency || 'USDT',
            ),
          ),
          disabledBtn: item.cardStatus === 'Rejected' ? false : item.cardStatus !== 'Unclaimed' ? true : false,
        };
      });
      this.sectionThreeLoading = false;
    });
  }

  /**
   * 決定最終幣種（優先順序：currentCurrency > currencyList首個 > 原始幣種）
   *
   * @param prizeCurrency
   * @param currencyList
   */
  private decideFinalCurrency(prizeCurrency: string, currencyList: string[]): string {
    if (!currencyList.length) return prizeCurrency;
    if (currencyList.includes(this.currentCurrency)) return this.currentCurrency;
    return currencyList.length === 1 ? currencyList[0] : prizeCurrency;
  }

  /**
   * 獲取目標幣種的匯率
   *
   * @param baseCurrency
   * @param targetCurrency
   */
  private getExchangeRate(baseCurrency: string, targetCurrency: string): number {
    return (
      this.userAssetsService
        .getRatesBaseCurrency(this.allRate, baseCurrency)
        .rates?.find((r: any) => r.currency === targetCurrency)?.rate || 1
    );
  }

  /**
   * 獲取相對於 USDT 的匯率
   *
   * @param currency
   */
  private getUsdtRate(currency: string): number {
    return this.allRate.rates?.find((r: any) => r.currency === currency)?.rate || 1;
  }

  /**
   * 格式化可用獎金數據
   */
  formatEligibleBonusData() {
    this.eligibleBonusList = this.eligibleBonusList.map(eb => {
      const prizeCurrency = eb.currency;
      const currencyList = eb.currencyList || [];
      const finalCurrency = this.decideFinalCurrency(prizeCurrency, currencyList);
      const rate = this.getExchangeRate(prizeCurrency, finalCurrency);
      const rateBaseUsdt = this.getUsdtRate(finalCurrency);

      return {
        ...eb,
        finalCurrency,
        finalMinBonusAmount: finalCurrency === prizeCurrency ? eb.minBonusAmount : eb.minBonusAmount / rate,
        finalMaxBonusAmount: finalCurrency === prizeCurrency ? eb.maxBonusAmount : eb.maxBonusAmount / rate,
        finalMinDeposit: eb.minDepositUsdt / rateBaseUsdt,
      };
    });
  }

  /**
   * 放棄激活獎金錢包
   *
   * @param item 激活獎金項目
   */
  openForfeitPopup(item: any) {
    let newBonusAmount = 0;
    let forfeitAmount = 0;
    this.forfeitDataLoading = true;
    this.newBonusWalletApi.getCancelNewBonusWalletInfo(item.newBonusWalletId).subscribe(res => {
      this.forfeitDataLoading = false;
      if (res) {
        forfeitAmount = res.forfeitAmount;
        newBonusAmount = res.newBonusAmount;
        this.csPopupService.confirm({
          header: 'FORFEIT BONUS',
          title: `Are you sure you want to forfeit your bonus?`,
          message: [
            `${newBonusAmount}${item.currency} will be deducted from the bonus wallet. You will receive ${forfeitAmount}${item.currency} into your Pubs wallet.`,
            'If the bonus wallet balance is insufficient, the remaining amount will be deducted from the Pubs Wallet.',
            'If you have any unsettled bets, the maximum amount you can be refunded is limited to your principal deposit.',
          ],
          confirmText: 'Forfeit',
          color: 'danger',
          textAlign: 'left',
          confirmCallback: async () => {
            this.newBonusWalletApi.cancelBonus(item.newBonusWalletId).subscribe(res => {
              if (res) {
                this.loadSectionOne();
                this.getActiveBonusData();
                this.toast.show({
                  title: 'Bonus Forfeited',
                  message: 'The bonus has been removed from your active bonuses.',
                  type: 'success',
                });
              } else {
                this.toast.show({ title: 'Unknown error', message: 'Please try again', type: 'fail' });
              }
            });
          },
        });
      } else {
        this.toast.show({ title: 'Unknown error', message: 'Please try again', type: 'fail' });
      }
    });
  }

  /**
   * 獲取激活的獎金錢包
   */
  getActiveBonusData(isIntoViewAfterFetched = false) {
    this.isActiveBonusLoading = true;
    this.newBonusWalletApi.getActiveBonus().subscribe(res => {
      this.activeBonusList = (res || []).map((item: ActiveBonus) => ({
        ...item,
        logo: this.walletTypeImageMap[item.walletType] || this.walletTypeImageMap['Default'],
        days: Math.floor((item.deadline - Date.now()) / (1000 * 60 * 60 * 24)),
        finalMinDeposit: item.minDepositUsdt / this.getUsdtRate(item.currency),
        finalCurrency: item.currency,
      }));
      this.isActiveBonusLoading = false;

      if (isIntoViewAfterFetched && this.bonusActiveRef.nativeElement) {
        this.bonusActiveRef.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  }

  /** 获取导航数据 */
  getInitData() {
    combineLatest([this.bonusApi.getBonusSelect(), this.bonusApi.getBonusTypeList()]).subscribe(
      ([selectRes, TypeListRes]) => {
        this.cardTypeList = [
          {
            title: this.localeService.getValue('all'),
            newTypeCode: 'All',
            typeCode: null,
            grantType: null,
          },
          ...TypeListRes,
        ];
        this.cardStatusList = [
          { code: '', description: this.localeService.getValue('all') },
          ...(selectRes?.data || []),
        ];
      },
    );
  }

  /**
   * 打開一般紅利規則
   *
   * @param item
   * @param isWallet
   */
  handleOpenBonusRule(item: BonusDetailList | ActiveBonus | EligibleBonus, type: 'detail' | 'active' | 'eligible') {
    this.matConnectedDialog.open(BonusesRulesComponent, {
      data: {
        type,
        item,
      } as BonusItem,
      mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
      mobileFixedBottom: true,
    });
  }

  /**
   * 打Locked資訊
   */
  handleOpenLockedBonuses() {
    this.matConnectedDialog.open(LockedBonusesComponent, {
      data: {
        lockedBonusAmount: this.lockedBonusAmount,
      },
      mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
      mobileFixedBottom: true,
    });
  }

  /**
   * 打開cashback領取資訊
   */
  handleOpenCashbackRedemption() {
    this.matConnectedDialog.open(CashbackRedemptionComponent, {
      data: this.cashbackData.multiCurrency,
      mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
      mobileFixedBottom: true,
    });
  }

  /**
   * 打開兌換碼
   */
  handleOpenRedeemCode() {
    this.matConnectedDialog.open(RedeemCodeComponent, {
      mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
      mobileFixedBottom: true,
    });
  }

  /**
   * 打開讓用戶選擇想兌換的幣種彈窗
   *
   * @param item
   */
  handleOpenClaimBonusByCurrency(item: any) {
    this.matConnectedDialog
      .open(ClaimBonusByCurrencyComponent, {
        data: {
          bonusData: item,
          cryptoCurrencies: this.cryptoCurrencies,
        },
        mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
        mobileFixedBottom: true,
      })
      .afterClosed()
      .subscribe((result: any) => {
        if (result?.success) {
          this.loadSectionThree();
        }
      });
  }

  /**
   * 領取long term bonus
   */
  handleClaimCashback() {
    if (Array.isArray(this.longTermBonusDetail)) {
      this.clickClaimCashbackLoading = true;

      const unclaimedIds = this.longTermBonusDetail
        .filter((bonus: any) => bonus.cardStatus === 'Unclaimed')
        .map((bonus: any) => bonus.id);

      if (unclaimedIds.length > 0) {
        const params = { bonusIds: unclaimedIds.join(',') };
        this.bonusApi
          .getReceiveBackwaters(params)
          .pipe(map(v => v?.data))
          .subscribe(data => {
            if (data) {
              this.toast.show({
                title: 'Cashback added',
                message: 'Your cashback is now in your PUBS wallet',
                type: 'success',
              });
              this.loadSectionOne();
            } else {
              this.toast.show({ title: 'Unknown error', message: 'Please try again', type: 'fail' });
            }
          });
      }
      this.clickClaimCashbackLoading = false;
    }
  }

  /**
   * 領取一般bonus
   *
   * @param item
   */
  claimBonus(item: any) {
    if (item.cardStatus === 'Unclaimed') {
      item.loading = true;

      this.bonusApi
        .getReceiveBackwater({ bonusId: item.id, grantType: item.grantType })
        .pipe(map(v => v?.data))
        .subscribe(data => {
          if (data) {
            this.toast.show({
              title: 'Bonus Claimed',
              message: 'Your bonus was claimed successfully.Check your transaction history for details.',
              type: 'success',
            });
            this.loadSectionThree();
          } else {
            this.toast.show({ title: 'Forfeit Active Bonus', message: 'Please try again', type: 'fail' });
          }
          item.loading = false;
        });
    }
  }

  /**
   * 檢查兩個幣種數組是否相同
   *
   * @param arr1
   * @param arr2
   */
  private isSameCurrencyArray(arr1: string[], arr2: string[]): boolean {
    const sorted1 = [...arr1].sort();
    const sorted2 = [...arr2].sort();
    return sorted1.length === sorted2.length && sorted1.every((c, i) => c === sorted2[i]);
  }

  /**
   * 獲取有效的目標幣種
   *
   * @param finalCurrency
   * @param currencyList
   */
  private getTargetCurrency(finalCurrency: string | undefined, currencyList: string[] | undefined): string {
    const currency = finalCurrency || 'USDT';

    if (!currencyList?.length) {
      return currency;
    }

    // Build supportedCurrencies following the order of currencyList
    const supportedCurrencies = (currencyList || []).filter(curr =>
      this.appService.currencies$.getValue().some((c: any) => c.currency === curr && c.isVisible && c.isDigital),
    );

    // If finalCurrency is USDT and the top wallet currency differs from USDT,
    // prefer the first supported currency from the list.
    if (finalCurrency === 'USDT' && this.currentCurrency && this.currentCurrency !== 'USDT') {
      return supportedCurrencies.length > 0 ? supportedCurrencies[0] : this.currentCurrency;
    }

    if (currencyList.includes(currency) && supportedCurrencies.includes(currency)) {
      return currency;
    }

    return supportedCurrencies.length > 0 ? supportedCurrencies[0] : currency;
  }

  /**
   * 處理用戶點擊激活獎金錢包
   *
   * @param item
   */
  handleActiveBonusWallet(item: any) {
    const isSameArray = this.isSameCurrencyArray(
      this.activeBonusList.map(item => item.currency),
      item.currencyList || [],
    );
    const currencyToUse = this.getTargetCurrency(item.finalCurrency, item.currencyList);
    const sameCurrency = this.activeBonusList.some(item => item.currency === currencyToUse);
    if (this.isFCFS(item.grantType)) {
      this.walletService.openDepositModalByLastDepositMode(currencyToUse, item.activityId);
      return;
    }

    if (isSameArray) {
      this.csPopupService.info({
        header: 'Forfeit Active bonus',
        message: 'Please forfeit the current active bonus before activating a new one.',
        confirmText: 'Close',
        textAlign: 'left',
      });
      return;
    }
    if (sameCurrency) {
      this.csPopupService.info({
        header: 'The reward currency you are attempting to activate is already activated.',
        message: 'Please forfeit the current active bonus before activating a new one.',
        confirmText: 'Close',
        textAlign: 'left',
      });
      return;
    }
    this.walletService.openDepositModalByLastDepositMode(currencyToUse, item.activityId);
  }

  /**
   * 整数去掉8位小数
   *
   * @param num
   * @returns
   */
  toParseInt(num: string | number): string | number {
    const data = num.toString().replace(',', '');
    if (Number(data) % 1 === 0) {
      return num.toString().split('.')[0];
    } else {
      return num;
    }
  }

  private parseConfigJson<T>(key: keyof TenantConfig['config']): T[] {
    const raw = this.appService.tenantConfig$.value?.config?.[key] as string;
    try {
      return JSON.parse(raw || '[]') as T[];
    } catch (error) {
      console.error(`Error parsing ${key}:`, error);
      return [];
    }
  }

  openQuestion(index: number): void {
    this.bonusFaqs[index].active = !this.bonusFaqs[index].active;
  }

  protected redirectToGame(item: BonusDetailList): void {
    // 轉換成 free spin / free chip 指定的遊戲幣種
    const { currency } = this.appService.currentCurrency$.getValue();
    const specifyCurrency = item.currency;
    if (currency !== specifyCurrency) {
      this.settingsService.setUserDefaultCurrency({ defaultCurrencyType: specifyCurrency }, specifyCurrency);
    }

    this.router.navigateByUrl(`${this.appService.languageCode}/casino/games/${item.providerCatId}/${item.gameId}`);
  }

  /**
   * 領取 Free Spin / Free Chip
   *
   * @param item
   */
  protected claimFreeBonus(item: BonusDetailList): void {
    if (item.cardStatus === 'Unclaimed') {
      item.loading = true;
      this.bonusApi
        .getReceiveBackwater({ bonusId: Number(item.id), grantType: item.grantType })
        .pipe(finalize(() => (item.loading = false)))
        .subscribe(res => {
          const { data } = res;

          if (!data) {
            this.toast.show({
              title: 'Forfeit Active Bonus',
              message: res?.message || 'Please try again',
              type: 'fail',
            });
            return;
          }

          if (!(item.withdrawFlowMultiple > 0)) {
            this.toast.show({
              title: 'Bonus Claimed',
              message: 'Your bonus was claimed successfully.Check your transaction history for details.',
              type: 'success',
            });
            this.loadSectionThree();
            return;
          }

          this.getActiveBonusData(true);
          this.loadSectionThree();
        });
    }
  }

  onImgError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.src = 'assets/images/game/default_en.png';
  }

  isFCFS(type: string | undefined): boolean {
    return type === 'FreeChip' || type === 'FreeSpin';
  }

  getRemainingRewardAmount(item: EligibleBonus): number | null {
    const eventClaimLimit = item.eventClaimLimit ?? 0;
    const eventClaimedCount = item.eventClaimedCount ?? 0;

    if (eventClaimLimit <= 0) {
      return null;
    }

    const remainingRewardAmount = eventClaimLimit - eventClaimedCount;

    return remainingRewardAmount > 0 ? remainingRewardAmount : null;
  }
}
